import React from 'react';
import { IconProps } from '../types/types';

const XAUUSD: React.FC<IconProps> = (props) => (
    <svg viewBox="0 0 39 41" fill="none" xmlns="http://www.w3.org/2000/svg" role="img" {...props}>
        <path d="M13.217 26.201c7.194 0 13.025-5.831 13.025-13.025S20.411.15 13.217.15.19 5.982.19 13.176 6.023 26.2 13.217 26.2Z" fill="#F0F0F0" />
        <path
            d="M12.656 13.175h13.592a13.04 13.04 0 0 0-.449-3.397H12.656v3.397ZM12.656 6.38h11.68a13.094 13.094 0 0 0-3.005-3.399h-8.675V6.38ZM13.221 26.2a12.97 12.97 0 0 0 8.108-2.83H5.113a12.97 12.97 0 0 0 8.108 2.83ZM2.108 19.971h22.227a12.95 12.95 0 0 0 1.463-3.398H.645a12.949 12.949 0 0 0 1.463 3.398Z"
            fill="#D80027"
        />
        <path
            d="M6.225 2.184h1.187l-1.104.803.422 1.298-1.104-.803-1.104.803.364-1.122A13.097 13.097 0 0 0 2.36 5.98h.38l-.703.51c-.11.183-.214.369-.315.557l.336 1.033-.627-.455c-.155.33-.298.667-.426 1.011l.37 1.138H2.74l-1.104.802.422 1.298-1.105-.802-.66.48a13.15 13.15 0 0 0-.102 1.625h13.026V.15c-2.573 0-4.972.747-6.992 2.034Zm.505 9.69-1.104-.803-1.104.802.421-1.298-1.104-.802h1.365l.422-1.298.421 1.298h1.365l-1.104.802.422 1.298ZM6.308 6.78l.422 1.298-1.104-.802-1.104.802.421-1.298-1.104-.802h1.365l.422-1.298.421 1.298h1.365l-1.104.802Zm5.094 5.092-1.104-.802-1.104.802.421-1.298-1.104-.802h1.365l.422-1.298.421 1.298h1.365l-1.104.802.422 1.298Zm-.422-5.092.422 1.298-1.104-.802-1.104.802.421-1.298-1.104-.802h1.365l.422-1.298.421 1.298h1.365l-1.104.802Zm0-3.794.422 1.298-1.104-.803-1.104.803.421-1.298-1.104-.803h1.365l.422-1.297.421 1.297h1.365l-1.104.803Z"
            fill="#0052B4"
        />
        <path
            d="M25.205 39.97c7.332 0 13.276-5.944 13.276-13.276s-5.944-13.275-13.276-13.275S11.93 19.361 11.93 26.694c0 7.332 5.943 13.275 13.275 13.275Z"
            fill="#E1A61A"
            stroke="#fff"
            strokeWidth={0.5}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M22.375 20.752a.241.241 0 0 0-.234.181l-1.037 4.065h8.201l-1.053-4.065a.241.241 0 0 0-.234-.181h-5.643Zm-.702.062a.724.724 0 0 1 .702-.545h5.643c.33 0 .618.223.701.542l1.054 4.066a.483.483 0 0 1-.468.604h-8.2a.483.483 0 0 1-.469-.602l1.037-4.065Z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.25}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M17.96 25.784a.241.241 0 0 0-.233.182L16.69 30.03h8.201l-1.053-4.066a.241.241 0 0 0-.234-.18H17.96Zm-.701.063a.724.724 0 0 1 .702-.546h5.643c.33 0 .618.223.701.543l1.054 4.066a.483.483 0 0 1-.468.604h-8.2a.483.483 0 0 1-.469-.603l1.037-4.064Z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.25}
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M26.785 25.784a.241.241 0 0 0-.234.182l-1.037 4.065h8.201l-1.053-4.066a.241.241 0 0 0-.234-.18h-5.643Zm-.702.063a.724.724 0 0 1 .702-.546h5.643c.33 0 .618.223.701.543l1.054 4.066a.483.483 0 0 1-.468.604h-8.2a.483.483 0 0 1-.468-.603l1.036-4.064Z"
            fill="#fff"
            stroke="#fff"
            strokeWidth={0.25}
        />
    </svg>
);

export default XAUUSD;
